import React from 'react';
import { Box, FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material';
import { ChargeMode } from 'src/types/transaction.types';

interface ChargeModeFieldProps {
  value: ChargeMode;
  onChange: (value: ChargeMode) => void;
}

/** Debit-only setting: take the charge at once, or send the scholar a bill to pay. */
export default function ChargeModeField({ value, onChange }: ChargeModeFieldProps): React.JSX.Element {
  return (
    <Box>
      <Typography
        id="charge-mode-label"
        variant="caption"
        sx={{ color: 'text.secondary', fontWeight: 600, mb: 0.75, display: 'block' }}
      >
        How is it charged? *
      </Typography>
      <RadioGroup
        aria-labelledby="charge-mode-label"
        name="chargeMode"
        value={value}
        onChange={(e) => onChange(e.target.value as ChargeMode)}
      >
        <FormControlLabel
          value="auto"
          control={<Radio size="small" />}
          label={
            <Typography variant="body2" sx={{ fontSize: '0.8125rem', fontWeight: 500 }}>
              Auto-charge — taken from the balance at once (fines, taxes, store purchases)
            </Typography>
          }
        />
        <FormControlLabel
          value="bill"
          control={<Radio size="small" />}
          label={
            <Typography variant="body2" sx={{ fontSize: '0.8125rem', fontWeight: 500 }}>
              Bill — the scholar must pay it and cannot deny it (rent, utilities)
            </Typography>
          }
        />
      </RadioGroup>
    </Box>
  );
}
